import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import SocialLogin from '../../components/auth/social';
import SignupForm from '../../components/forms/signup';
import LoginForm from '../../components/forms/login';

import style from './index.module.scss';

function AuthPage() {
  return (
    <div className={style.auth}>
      <div className={style['auth-card']}>
        <Switch>
          <Route path='/auth' exact component={SignupForm} />
          <Route path='/auth/login' component={LoginForm} />
        </Switch>
      </div>
    </div>
  );
}

export default AuthPage;
